<template>
  <div class="rt-select">
    <van-field v-model="result" v-bind="$attrs" readonly is-link @click="show = !show" />
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="onConfirm"
        @cancel="cancel"
        cancel-button-text="清除"
        :item-height="$vanItemHeight"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  model: {
    prop: "selectValue"
  },
  props: {
    columns: {
      type: Array
    },
    selectValue: {
      type: String
    }
  },
  data() {
    return {
      show: false,
      result: this.selectValue,
      currentDate: new Date()
    };
  },
  methods: {
    onConfirm(value) {
      if (!value) {
        this.result = "";
      } else {
        this.result = this.$format(value);
      }

      this.show = !this.show;
    },
    cancel() {
      // this.show = !this.show;
      this.onConfirm("");
    }
  },
  watch: {
    selectValue: function(newVal) {
      this.result = newVal;
    },
    result(newVal) {
      this.$emit("input", newVal);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>